/**
 * Created by r4zi4l on 20.08.2021
 */

Families.initialize = function () {
    Families.initializeBase();

    AdventureFamilies.register();

    Families.DELETED_STAGES.wood = [7];
    Families.DELETED_STAGES.stone = [7];

    Families.DELETED_STAGES.bear = [1];
    Families.DELETED_STAGES.elf = [4];
    Families.DELETED_STAGES.warlock = [3];
    Families.DELETED_STAGES.troll = [6];
    Families.DELETED_STAGES.knight = [4];

    Families.DELETED_STAGES.woodgenerator = [1, 2];
    Families.DELETED_STAGES.stonegenerator = [1, 2];
    Families.DELETED_STAGES.wagongenerator = [1, 2];
    Families.DELETED_STAGES.bamboogenerator = [1, 2];
    Families.DELETED_STAGES.sapphiregenerator = [1, 2];
    Families.DELETED_STAGES.snowgenerator = [1, 2];
    Families.DELETED_STAGES.lavagenerator = [1, 2];
    Families.DELETED_STAGES.sandgenerator = [1, 2];
    Families.DELETED_STAGES.asiagenerator = [1, 2];
    Families.DELETED_STAGES.warcraftgenerator = [1, 2];
    Families.DELETED_STAGES.steampunkgenerator = [1, 2];
    Families.DELETED_STAGES.moonstonegenerator = [1, 2];
    Families.DELETED_STAGES.leafgenerator = [1, 2];
    Families.DELETED_STAGES.textilegenerator = [1, 2];
    Families.DELETED_STAGES.cardgenerator = [1, 2];

    ["wax", "waxchest", "waxsource", "waxgenerator"].forEach((code) => {
        Families.DEBUG_ONLY[code] = true;
    });

    if (!cleverapps.config.debugMode) {
        Object.keys(Families.DEBUG_ONLY).forEach((code) => {
            delete Families[code];
        });
    }

    Families.afterInitialize();
};

if (typeof cc === "undefined") {
    module.exports = Families;
}
